import { render, staticRenderFns } from "./RsaSchedaAachenerAphasieTestRipetizioneEditComponent.vue?vue&type=template&id=e1e04762&scoped=true"
import script from "./RsaSchedaAachenerAphasieTestRipetizioneEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAachenerAphasieTestRipetizioneEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaAachenerAphasieTestRipetizioneEditComponent.vue?vue&type=style&index=0&id=e1e04762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e04762",
  null
  
)

export default component.exports